import { render, staticRenderFns } from "./VCombobox.vue?vue&type=template&id=089515e0&scoped=true"
import script from "./VCombobox.vue?vue&type=script&lang=js"
export * from "./VCombobox.vue?vue&type=script&lang=js"
import style0 from "./VCombobox.vue?vue&type=style&index=0&id=089515e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089515e0",
  null
  
)

export default component.exports